import React from 'react';

import config from 'config';

import {resetPasswordClick} from '../../services/user/api';
import {handleChange} from "../../utils/ComponentUtilFunctions";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import BlueButton from "../../components-new/buttons/BlueButton";
import SilverButton from "../../components-new/buttons/SilverButton";
import Input from "../../components-new/form/Input";
import EmailIcon from '../../assets/icons/EmailIcon';


class ForgotPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            disabled: false,
            error: null
        };
        this.handleChange = handleChange.bind(this);
    }

    reset = (event) => {
        event.preventDefault();
        const {
            email, disabled,
        } = this.state;

        if (disabled) {
            return;
        }

        this.setState({
            disabled: true,
        });

        const {addNotification} = this.props;

        resetPasswordClick(
            email,
        ).then(() => {
            addNotification('mailWasSent', config.notificationLevels.success);
            setTimeout(() => {
                window.location.href = config.APP_HOST + '/login'
            }, 1000);
        }).catch((e) => {
            this.setState({
                disabled: false,
                error: e.response.data
            });

            if (e.response && e.response.data === "") {
                addNotification('somethingWentWrong', config.notificationLevels.error);
            } else {
                addNotification(e.response.data, config.notificationLevels.error);
            }
        });
    };

    render() {
        const {email} = this.state;

        return (
            <div>
                <h1 className="form-header">
                    Password recovery
                </h1>

                <p className="auth-form-description">
                    Please enter your registered email address. We’ll send you steps to recover your account.
                </p>

                <form className="auth-form" onSubmit={(e) => {
                    e.preventDefault();
                    return false;
                }}>

                    <Input
                        type="text"
                        label="Email"
                        leadingIcon={<EmailIcon width={20} height={20}/>}
                        name={'email'}
                        placeholder="Email"
                        value={email}
                        onChange={this.handleChange('email')}
                    />

                    <BlueButton className="auth-submit-button" height={36} type={'submit'} onClick={this.reset} children={'Send'}/>

                    <div className="auth-form-link">
                        <Link to="/login" className="auth-form-link-button">
                            <SilverButton asDiv variant="ghost" height={36}>
                                Sign-In
                            </SilverButton>
                        </Link>
                    </div>

                </form>

            </div>
        );
    }
}

ForgotPassword.propTypes = {
    match: PropTypes.object,
    addNotification: PropTypes.func.isRequired,
};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/scenes/auth/ForgotPassword.jsx